<template>
	<div class="slide">
		<PageBanner></PageBanner>
		<div id="title" class="slide_title">
			<span class="slide_eng_title">FACSCOPE</span> 一次性计数板
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="slide_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">一次性计数板</p>
			<p class="p2">FACSCOPE</p>
			<p class="p3">FACSCOPE细胞计数板是一款精确的一次性计数板，设计用于FACSCOPE B<br>
				自动细胞计数仪。降低了用户接触感染性/有害样品的风险，并通过消除清洗<br>
				和高压灭菌过程提高了效率。</p>
			<img src="../assets/img/production/Slide_2.png" class="slide_img" />
		</div>
		<p class="exp3">FACSCOPE细胞计数板是一款精确的一次性计数板，设计用于FACSCOPE B
			自动细胞计数仪。降低了用户接触感染性/有害样品的风险，并通过消除清洗
			和高压灭菌过程提高了效率。</p>
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 3vh;">提高效率</p>
		<p id="title" class="subtext">通过消除清洗和高压灭菌减少了不便利之处。</p>
		<p id="title" class="maintext">精确控制计数体积</p>
		<p id="title" class="subtext">通过精确的腔深100µm控制计数体积。</p>
		<p id="title" class="maintext">降低成本</p>
		<p id="title" class="subtext">一次性计数4个样本。</p>
		<p id="title" class="maintext">提高安全性</p>
		<p id="title" class="subtext">降低了用户接触感染性/有害样品的风险</p>
		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'Slide',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".slide_container"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 10vh;
	}

	.subtext {
		font-size: 18px;
	}

	.slide_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 400px;
		width: 1200px;
	}

	.slide_container p {
		position: absolute;
	}

	.slide_container .p1 {
		margin-right: 820px;
		margin-bottom: 230px;
		font-size: 28px;
	}

	.slide_container .p2 {
		margin-right: 740px;
		margin-bottom: 130px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.slide_container .p3 {
		margin-right: 400px;
		margin-top: 170px;
		font-size: 18px;
		line-height: 2;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.slide_title {
		font-size: 2em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.slide_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.slide_img {
		position: absolute;
		width: auto;
		height: 300px;
		margin-left: 680px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.exp3 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.slide_container .p1 {
			margin-right: 650px;
			font-size: 1.5rem;
		}

		.slide_container .p2 {
			margin-right: 630px;
			font-size: 2rem;
		}

		.slide_container .p3 {
			margin-right: 270px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.slide_img {
			width: auto;
			height: 250px;
			margin-left: 630px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.slide_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.slide_eng_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.slide_container .p1, .slide_container .p2 {
			font-size: 1.2rem;
			margin-right: 200px;
			margin-top: 180px;
		}

		.slide_container .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.slide_img {
			position: absolute;
			height: 150px;
			width: auto;
			margin-top: 20px;
			margin-left: 160px;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}
	}
</style>